module.exports = __webpack_public_path__ + "img/FA.0cdd434c.jpg";